export const UMO_CAROUSEL_NEXT = 'UMO_CAROUSEL_NEXT';
export const UMO_CAROUSEL_PREV = 'UMO_CAROUSEL_PREV';
export const UMO_CAROUSEL_MAX_INDEX = 'UMO_CAROUSEL_MAX_INDEX';
export const UMO_CAROUSEL_SET_INDEX = 'UMO_CAROUSEL_SET_INDEX';
